import { CircularProgress, Divider, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import React, { useEffect, useState } from 'react';
import InputSelector from '../UI/InputSelector';
import customAxios from '../../utils/customAxios';
import { GlobalVariables } from '../../globalVar';
import { getToast } from '../../utils/toastConfig';
import variables from '../../scss/_variables.scss';

const ConfigAlerts = () => {
  // State variables
  const [sections, setSections] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [sectionInfo, setSectionInfo] = useState();

  // Axios
  const headers = {
    Authorization: 'bearer ' + localStorage.getItem('token'),
  };
  const sectionsEndpoint = `${GlobalVariables.getURL()}config/modules/2/sections`;
  const optionsEndpoint = (sectionId) =>
    `${GlobalVariables.getURL()}config/modules/sections/${sectionId}/options`;
  const updateOptionsEndpoint = `${GlobalVariables.getURL()}config/modules/sections/options/update`;

  const cbUpdateOption = async (optionData) => {
    try {
      // Because endpoint expects an array, we just send an array with one option
      const response = await customAxios.patch(
        updateOptionsEndpoint,
        [optionData],
        { headers }
      );
    } catch (error) {
      console.log(error);
      getToast({ status: 'error', title: error.response.data.message });
      await getSections([]);
    }
  };

  const getSections = async () => {
    setIsLoading(true);
    try {
      const maxRowsPerColumn = 1000; // Number of options per column
      const columns = []; // Options divided by columns
      // Get response from endpoint
      const response = await customAxios.get(sectionsEndpoint, { headers });
      // For each section, get the options by section id and store them inside the section with an "options" array
      const sectionData = await Promise.all(
        response.data.data.map(async (section) => {
          const optionResponse = await customAxios.get(
            optionsEndpoint(section.id),
            { headers }
          );
          if (optionResponse.status !== 200)
            return new Promise((resolve, reject) => resolve(null));

          const options = optionResponse.data.data;
          // With the maxRowsPerColumn, we slice the options array into columns
          for (let i = 0; i < options.length; i += maxRowsPerColumn) {
            columns.push(options.slice(i, i + maxRowsPerColumn));
          }

          return new Promise((resolve, reject) => {
            resolve({ ...section, columns });
          });
        })
      );
      setSectionInfo(sectionData[0]);
      setSections(sectionData);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setSections([]);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getSections();
  }, []);

  return (
    <div className='full-container'>
      <Grid2 container flexDirection='column' sx={{ mt: 2, mb: 1 }}>
        <Typography fontSize={18} fontWeight='bold'>
          Configuración de Alertas
        </Typography>
        <Typography fontSize={14} color='rgba(0,0,0,0.5)'>
          Personaliza el comportamiento de las alertas
        </Typography>
      </Grid2>
      <Divider sx={{ borderColor: 'black' }} />
      <Grid2 container flexDirection='column' sx={{ mt: 2, mb: 1 }}>
        <Typography>{sectionInfo && sectionInfo.label}</Typography>
        <Typography fontSize={14} color='rgba(0,0,0,0.5)'>
          {sectionInfo && sectionInfo.description}
        </Typography>
      </Grid2>

      {isLoading ? (
        <Grid2
          container
          alignItems='center'
          justifyContent='center'
          width='100%'
        >
          <CircularProgress sx={{ color: variables.redDabi, mt: 10 }} />
        </Grid2>
      ) : (
        <Grid2 container spacing={2} overflow={'scroll'} height='100%'>
          {sections.length > 0 &&
            sections.map((section, index) => (
              <Grid2 id='section' xs={12}>
                <div id='description' key={index} style={{ marginBottom: 10 }}>
                  <Grid2 container spacing={50}>
                    {section.columns.length > 0 &&
                      section.columns.map((columnItem, columnIndex) => (
                        <Grid2 key={columnIndex} xs={12}>
                          <Grid2
                            key={columnIndex}
                            container
                            direction='column'
                            spacing={1}
                          >
                            {columnItem.length > 0 &&
                              columnItem.map((item, itemIndex) => (
                                <Grid2
                                  key={itemIndex}
                                  display='flex'
                                  alignItems='center'
                                  gap={10}
                                >
                                  <Typography
                                    key={itemIndex}
                                    sx={{ fontSize: 14, fontWeight: 'bold' }}
                                  >
                                    {item.label}
                                  </Typography>
                                  <InputSelector
                                    optionData={item}
                                    key={itemIndex}
                                    cb={cbUpdateOption}
                                  />
                                </Grid2>
                              ))}
                          </Grid2>
                        </Grid2>
                      ))}
                  </Grid2>
                </div>
                <Divider sx={{ borderColor: 'rgba(0,0,0,0.5)' }} />
              </Grid2>
            ))}
        </Grid2>
      )}
    </div>
  );
};

export default ConfigAlerts;
